/**
 * This component composes FormPageLayout with the SignupDirectProgress component which shows the progress of the signup process.
 */
import { FormPageLayout } from '@expressable/syntax-ds';
import { Outlet } from 'react-router-dom';
import { SignupDirectProgress } from './SignupDirectProgress';
import { useFlags } from 'launchdarkly-react-client-sdk';

export const SignupFormPageLayoutWithProgressBar = () => {
  const { signupDirectProgressBar } = useFlags();

  return (
    <FormPageLayout variant="full">
      {signupDirectProgressBar && <SignupDirectProgress />}
      <Outlet />
    </FormPageLayout>
  );
};
